
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CommonUtils from "@/common-utils";
import axios from "axios";
import { SchoolNoticeIVO, SchoolNoticeSlvVO, SchoolNoticeVO } from '@/views/biz/notice/vo/CalendarVO';

@Component
export default class SchoolNoticeForm extends Vue {
  @Prop() snNo!: string;

  // 학교주요소식 메인 달력
  snFullDateMenu = false;
  snFullDate;

  dates = [];
  times = [];
  dialog = false;
  e7 = null;

  mstSchoolNotice = {} as SchoolNoticeVO;
  slvSchoolNotice = [] as Array<SchoolNoticeSlvVO>;

  currentNotiIndex;

  parseDate(date) {
    if (!date) return null
    const [month, day, year] = date.split('/')
    return `${year}년 ${month.padStart(2, '0')}월`
  }

  // 저장
  async saveForm() {
    const res = await this.$confirm(
      "저장 하시겠어요?",
      CommonUtils.baseConfirmOption
    );

    if(!res) {
      return;
    }

    const param = {} as SchoolNoticeIVO;
    param.notice = this.mstSchoolNotice;
    param.notice.snYear = this.mstSchoolNotice.snFullDate.split('-')[0];
    param.notice.snMonth = this.mstSchoolNotice.snFullDate.split('-')[1];
    param.notice.snContent = this.getNoticeContent();
    param.noticeDetails = this.slvSchoolNotice;

    if(this.snNo) {
      axios.put('/admin/notice/school', param).then(r=> {
        this.$toast('수정됐어요');
        this.$router.push({name: 'AdminSchoolNotices'})
      })
      return;
    }

    axios.post('/admin/notice/school', param).then(r=> {
      this.$toast('저장됐어요');
      this.$router.push({name: 'AdminSchoolNotices'})
    })
  }

  getNoticeContent() {
    let snContent = `${this.mstSchoolNotice.snMonth}월 학교 소식<br><br>`;
    this.slvSchoolNotice.forEach((v, i)=>{
      if(v.imptYn == 'Y') {
        snContent += `<span class="mark">`;
      }
      snContent += `${i+1})`;

      if(v.ssStartDt) {
        snContent += `${v.ssStartDt.substring(0, 10)}`;
      }

      if(v.ssEndDt) {
        snContent += ` ~ ${v.ssEndDt.substring(0, 10)}`;
      }

      snContent += `<br>  - ${v.ssContent}<br><br>`;

      if(v.imptYn == 'Y') {
        snContent += `</span>`;
      }
    })

    if(this.mstSchoolNotice.snSrc) {
      snContent += `+ 자료출처 : <span class="mark">${this.mstSchoolNotice.snSrc}</span><br> 감사합니다.`;
    }

    return snContent;
  }

  newSchedules() {
    const newForm = {} as SchoolNoticeSlvVO;
    this.slvSchoolNotice.push(newForm);
  }

  removeSchedule(index: number) {
    this.slvSchoolNotice.splice(index, 1)
  }

  selectColor(index) {
    this.currentNotiIndex = index;
    this.$set(this.slvSchoolNotice[this.currentNotiIndex], 'isColorPicker', !this.slvSchoolNotice[this.currentNotiIndex].isColorPicker);
  }

  changeColor(e) {
    this.$set(this.slvSchoolNotice[this.currentNotiIndex], 'ssColor', e.hex)
  }

  cancel() {
    this.$router.go(-1)
  }

  created() {
    if(!this.snNo) {
      return;
    }
    
    axios.get(`admin/notice/school/${this.snNo}`)
    .then(r=>{
      this.mstSchoolNotice = r.data.notice;
      this.slvSchoolNotice = r.data.schedules;
    })
  }

}
